import _ from "lodash/fp";
import React from "react";
import {Button, ButtonGroup, ButtonToolbar, Dropdown, Glyphicon, MenuItem} from "react-bootstrap";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {createSigntask} from "../../stores/signtasks/createSigntask";
import Document from "./Document";
import Person from "./Signer";
import Reference from "./Reference";
import CreateTemplate from "./Template/CreateTemplate";
import SelectTemplate from "./Template/SelectTemplate";
import {randomString} from "../../utilities/random";
import {isFilled} from "../../utilities/isfilled";
import { withTranslation } from 'react-i18next';

export const {Provider, Consumer} = React.createContext();

const newDocument = () => ({title: "", content: ""});
const newSigner = () => ({name: "", ssn: "", email: "", phone: ""});
const newSigntask = () => ({
  //reference: randomString(10),
  documents: [newDocument()],
  signers: [newSigner()]
});

export default withRouter(withTranslation()(connect(
  undefined,
  dispatch => ({
    createSigntask: _.compose(dispatch, createSigntask)
  })
)(class extends React.Component {
  state = {
    ...newSigntask(),
    transmitting: false
  };

  addDocument = () => this.setState(state => ({documents: [...state.documents, newDocument()]}));
  addSigner = () => this.setState(state => ({signers: [...state.signers, newSigner()]}));
  removeSigner = () => {
    const signers = [...this.state.signers];
    signers.pop();
    this.setState(state => ({ signers: [...signers] }));
  }
  updateReference = reference => this.setState({reference});
  updateDocument = idx => delta => {
    const documents = _.set(idx, _.merge(this.state.documents[idx], delta), this.state.documents);
    this.setState({documents});
    if (idx === documents.length - 1) this.addDocument();
  };
  updateDocuments = documents => {
    this.setState({documents});
    if (isFilled("title", "content")(_.last(documents) || {})) this.addDocument();
  };
  updateSigner = idx => delta => {
    const signers = _.set(idx, _.merge(this.state.signers[idx], delta), this.state.signers);
    this.setState({signers});
  };
  updateSigners = signers => {
    this.setState({signers});
    if (signers.length === 0) this.addSigner();
  };

  submitSigntask = () => {
    this.setState({transmitting: true});

    this.props.createSigntask(this.getData())
      .then(signtask => {
        this.setState({transmitting: false});

        if (signtask) {
          this.setState({...newSigntask()});
          this.props.history.push(`/sign-task/${signtask.id}`);
        }
      });
  };

  selectTemplate = React.createRef();
  createTemplate = React.createRef();

  getData = () => _.pick(["reference", "documents", "signers"], this.state);
  getGetters = () => _.pick(["getData"], this);
  getUpdaters = () => _.pick([
    "updateReference",
    "updateDocument", "updateDocuments",
    "updateSigner", "updateSigners"
  ], this);
  getContext = () => ({...this.getData(), ...this.getGetters(), ...this.getUpdaters()});
  
  render () {
    const { t } = this.props;
    return (
    <Provider value={this.getContext()}>
      <form id="createSigntask" method="post" onSubmit={event => event.preventDefault()}>
              <h2 className="text-center">{t('create_signtask_heading')}</h2>
              <br />
              <h4 className="text-center">{t('create_signtask_subheading')}</h4>
              <br />
        <Reference />
        <h4 className="text-center">{t('create_signtask_document_heading')}</h4>
        {_.map(idx => <Document key={idx} idx={idx} />, _.range(0, this.state.documents.length))}
        {_.map(idx => (
          <div key={idx} >
            <h4 className="text-center">{t('create_signtask_signer_heading')} {idx + 1} {idx === 0 ? t('create_signtask_signer_main_signer') : undefined}</h4>
            <Person idx={idx} />
          </div>
        ), _.range(0, this.state.signers.length))}
              <ButtonGroup className="pull-right">
                  <Button disabled={this.state.signers.length === 1} onClick={this.removeSigner}>{t('create_signtask_signer_btn_remove')}</Button>
                  <Button onClick={this.addSigner}>{t('create_signtask_signer_btn_add')}</Button>
                  <Button onClick={this.submitSigntask} disabled={this.state.transmitting}>{t('create_signtask_btn_submit')}</Button>
              </ButtonGroup>
        {/*<SelectTemplate ref={this.selectTemplate} />*/}
        <CreateTemplate ref={this.createTemplate} />
      </form>
    </Provider>
  );
  }
})));
